import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import RevenueReconciliationReportContMain from "presentation/view/container/RevenueReconciliationReport/RevenueReconciliationReportContMain";

CommonEntrypoint(<RevenueReconciliationReportContMain />)